module.exports = __webpack_public_path__ + "img/trash.e39a7127.svg";